import Phaser from 'phaser';
import TextTypingPlugin from 'phaser3-rex-plugins/plugins/texttyping-plugin.js';
import { GAME_WIDTH, GAME_HEIGHT, TILE_SIZE } from './constants';
import { BootScene } from '../scenes/BootScene';
import { PreloadScene } from '../scenes/PreloadScene';
import { WorldScene } from '../scenes/WorldScene';
import { DungeonScene } from '../scenes/DungeonScene';
import { EncounterScene } from '../scenes/EncounterScene';
import { JudgmentScene } from '../scenes/JudgmentScene';
import { AssetLabScene } from '../scenes/AssetLabScene';
import { LimoArrivalScene } from '../scenes/LimoArrivalScene';

// Re-export constants for backwards compatibility
export { GAME_WIDTH, GAME_HEIGHT, TILE_SIZE };

export const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  parent: 'game-container',
  backgroundColor: '#1a1a2e',
  pixelArt: true,
  plugins: {
    global: [
      {
        key: 'rexTextTyping',
        plugin: TextTypingPlugin,
        start: true,
      },
    ],
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    max: {
      width: GAME_WIDTH * 2,
      height: GAME_HEIGHT * 2,
    },
  },
  scene: [
    BootScene,
    PreloadScene,
    LimoArrivalScene,
    WorldScene,
    DungeonScene,
    EncounterScene,
    JudgmentScene,
    AssetLabScene,
  ],
};
